import { RestartAltRounded } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';
import { Alert, Button, Checkbox, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, FormControlLabel, FormHelperText, Grid, IconButton, InputAdornment, InputLabel, OutlinedInput, Stack, Typography, } from '@mui/material';
import { useAsyncAction, useRandomPassword, useStateRef } from 'app/services';
import { userUpdatePassword } from 'app/store/user';
import { resolveApiErrorMessage } from 'app/utils/apiError';
import React, { useEffect, useImperativeHandle, useLayoutEffect, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
export default function UpdatePassword({ selectedItem }) {
    const { password, generateRandomPassword } = useRandomPassword();
    const { asyncAction: updatePassSubmit, isLoading: isUpdatePassLoading, isSuccessful: isUpdatePassSuccessful, isError: isUpdatePassError, error: updatePassError, } = useAsyncAction(userUpdatePassword, [selectedItem]);
    const [open, setOpen] = useState(false);
    const { reset, register, formState, handleSubmit, getValues, setValue, setFocus, watch } = useForm({
        defaultValues: {
            password: '',
            // По умолчанию не обязываем — только если чекбокс отмечен.
            must_change_password: false,
        },
    });
    const mustChangePassword = watch('must_change_password');
    const [firstUpdate, setFirstUpdate, firstUpdateRef] = useStateRef(false);
    useLayoutEffect(() => {
        if (firstUpdateRef.current !== undefined) {
            setTimeout(() => setFirstUpdate(undefined));
        }
    }, [firstUpdateRef.current]);
    const handleOpenConfirm = () => {
        if (!config.passwordPolicyPattern.test(getValues().password)) {
            return;
        }
        setOpen(true);
    };
    const handleCloseConfirm = () => {
        setOpen(false);
    };
    const handleConfirmSubmit = (params) => {
        updatePassSubmit(selectedItem.id, params);
        setOpen(false);
        reset({
            password: '',
            must_change_password: false,
        });
    };
    const ref = useRef(null);
    useImperativeHandle(ref, () => ({
        handleFormSubmit: () => {
            handleSubmit((data) => handleConfirmSubmit({
                password: data.password,
                must_change_password: !!data.must_change_password,
            }))();
        },
    }), []);
    const handleFormClick = () => {
        var _a;
        if (!getValues('password'))
            return;
        (_a = ref.current) === null || _a === void 0 ? void 0 : _a.handleFormSubmit();
    };
    useEffect(() => {
        reset({
            password: '',
            must_change_password: false,
        });
    }, [selectedItem]);
    useEffect(() => {
        if (newPass) {
            setValue('password', password, {
                shouldDirty: true,
                shouldValidate: true,
                shouldTouch: true,
            });
            setNewPass(false);
        }
    }, [password]);
    const [newPass, setNewPass] = useState(false);
    const handleGenerateRandomPassword = () => {
        setFocus('password');
        generateRandomPassword();
        setNewPass(true);
    };
    return (React.createElement("form", null,
        React.createElement(Grid, { container: true },
            React.createElement(Stack, { direction: 'column', alignItems: 'center', sx: (theme) => ({
                    width: '100%',
                    position: 'relative',
                    marginTop: theme.spacing(3),
                    padding: theme.spacing(2),
                    border: '1px solid',
                    borderRadius: theme.shape.borderRadius,
                    borderColor: theme.palette.divider,
                    bgcolor: 'background.paper',
                    '.MuiAlert-root': {
                        marginTop: theme.spacing(0),
                        marginBottom: theme.spacing(3),
                    },
                }) },
                React.createElement(Stack, { direction: 'column', sx: (theme) => ({
                        width: '100%',
                        paddingBottom: theme.spacing(3),
                        '.MuiTypography-h6': {
                            fontSize: '15px',
                        },
                        '.MuiTypography-caption': {
                            color: theme.palette.text.secondary,
                        },
                    }) },
                    React.createElement(Typography, { variant: 'h6' }, "\u041E\u0431\u043D\u043E\u0432\u0438\u0442\u044C \u043F\u0430\u0440\u043E\u043B\u044C \u0434\u043B\u044F \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F"),
                    React.createElement(Typography, { variant: 'caption' }, "\u041C\u043E\u0436\u043D\u043E \u0443\u0434\u0430\u043B\u0438\u0442\u044C \u0434\u0430\u043D\u043D\u043E\u0433\u043E \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F, \u043D\u043E \u044D\u0442\u043E \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0435 \u043D\u0435\u043E\u0431\u0440\u0430\u0442\u0438\u043C\u043E. \u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0431\u0443\u0434\u044C\u0442\u0435 \u0443\u0432\u0435\u0440\u0435\u043D\u044B, \u0447\u0442\u043E \u0412\u044B \u0445\u043E\u0442\u0438\u0442\u0435 \u044D\u0442\u043E \u0441\u0434\u0435\u043B\u0430\u0442\u044C.")),
                React.createElement(Stack, { direction: 'column', justifyContent: 'flex-end', sx: (theme) => ({
                        width: '100%',
                        '.MuiAlert-root': {
                            width: '100%',
                            marginTop: theme.spacing(1),
                            borderRadius: theme.shape.borderRadius,
                        },
                    }) },
                    React.createElement(FormControl, { error: !!formState.errors.password, margin: 'normal', variant: 'outlined', fullWidth: true },
                        React.createElement(InputLabel, { disableAnimation: firstUpdate }, "\u041F\u0430\u0440\u043E\u043B\u044C"),
                        React.createElement(OutlinedInput, Object.assign({ label: '\u041F\u0430\u0440\u043E\u043B\u044C', notched: firstUpdate, fullWidth: true, placeholder: '\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043F\u0430\u0440\u043E\u043B\u044C', endAdornment: React.createElement(InputAdornment, { position: 'end' },
                                React.createElement(IconButton, { onClick: handleGenerateRandomPassword },
                                    React.createElement(RestartAltRounded, { fontSize: 'small' }))) }, register('password', {
                            required: false,
                            pattern: config.passwordPolicyPattern,
                        }))),
                        React.createElement(FormHelperText, null,
                            "\u041D\u0435 \u043A\u043E\u0440\u043E\u0447\u0435 ",
                            config.passwordPolicyLength,
                            " \u0441\u0438\u043C\u0432\u043E\u043B\u043E\u0432: \u0437\u0430\u0433\u043B\u0430\u0432\u043D\u0430\u044F \u0438 \u0441\u0442\u0440\u043E\u0447\u043D\u0430\u044F \u0431\u0443\u043A\u0432\u044B \u0438 \u0446\u0438\u0444\u0440\u0430. \u0418\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0439\u0442\u0435 \u0441\u0433\u0435\u043D\u0435\u0440\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0439 \u043F\u0430\u0440\u043E\u043B\u044C \u0438\u043B\u0438 \u0437\u0430\u0434\u0430\u0439\u0442\u0435 \u0435\u0433\u043E \u0441\u0430\u043C\u043E\u0441\u0442\u043E\u044F\u0442\u0435\u043B\u044C\u043D\u043E. \u041F\u043E\u043C\u043D\u0438\u0442\u0435, \u0447\u0442\u043E \u0434\u043B\u044F \u0432\u0445\u043E\u0434\u0430 \u0432 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044E \u0431\u0443\u0434\u0435\u0442 \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E \u0443\u043A\u0430\u0437\u0430\u0442\u044C \u0434\u0430\u043D\u043D\u044B\u0439 \u043F\u0430\u0440\u043E\u043B\u044C."),
                        !isUpdatePassLoading && isUpdatePassError && (React.createElement(Alert, { severity: 'error' }, resolveApiErrorMessage(updatePassError, 'Произошла ошибка при обновлении данных. Попробуйте снова или обратитесь в техническую поддержку.'))),
                        !isUpdatePassLoading && isUpdatePassSuccessful && React.createElement(Alert, { severity: 'success' }, "\u0414\u0430\u043D\u043D\u044B\u0435 \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u044B.")),
                    React.createElement(FormControlLabel, { label: '\u041E\u0431\u044F\u0437\u0430\u0442\u044C \u0441\u043C\u0435\u043D\u0438\u0442\u044C \u043F\u0430\u0440\u043E\u043B\u044C \u043F\u0440\u0438 \u043F\u0435\u0440\u0432\u043E\u043C \u0432\u0445\u043E\u0434\u0435', control: React.createElement(Checkbox, Object.assign({ size: 'small', disableRipple: true }, register('must_change_password'))) }),
                    React.createElement(FormHelperText, null, mustChangePassword
                        ? 'После входа пользователь окажется на экране смены пароля и не сможет работать, пока не задаст собственный.'
                        : 'Пользователь сможет сразу работать с новым паролем.')),
                React.createElement(Stack, { direction: 'row', justifyContent: 'flex-end', sx: (theme) => ({
                        width: '100%',
                        paddingTop: theme.spacing(0),
                    }) },
                    React.createElement(LoadingButton, { color: 'error', variant: 'contained', onClick: handleOpenConfirm, loading: isUpdatePassLoading, disableElevation: true }, "\u041E\u0431\u043D\u043E\u0432\u0438\u0442\u044C \u043F\u0430\u0440\u043E\u043B\u044C \u0434\u043B\u044F \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F"))),
            React.createElement(Dialog, { open: open, keepMounted: true, onClose: handleCloseConfirm, "aria-describedby": 'alert-dialog-slide-description' },
                React.createElement(DialogTitle, null, "\u0412\u044B \u0443\u0432\u0435\u0440\u0435\u043D\u044B \u0447\u0442\u043E \u0445\u043E\u0442\u0438\u0442\u0435 \u043E\u0431\u043D\u043E\u0432\u0438\u0442\u044C \u043F\u0430\u0440\u043E\u043B\u044C \u0434\u043B\u044F \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F?"),
                React.createElement(DialogContent, null,
                    React.createElement(DialogContentText, { id: 'alert-dialog-slide-description' }, "\u0412\u044B \u0442\u043E\u0447\u043D\u043E \u0443\u0432\u0435\u0440\u0435\u043D\u044B \u0447\u0442\u043E \u0445\u043E\u0442\u0438\u0442\u0435 \u043E\u0431\u043D\u043E\u0432\u0438\u0442\u044C \u043F\u0430\u0440\u043E\u043B\u044C \u0434\u043B\u044F \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F?")),
                React.createElement(DialogActions, null,
                    React.createElement(Button, { onClick: handleCloseConfirm }, "\u041E\u0442\u043C\u0435\u043D\u0430"),
                    React.createElement(Button, { onClick: handleFormClick }, "\u041E\u0431\u043D\u043E\u0432\u0438\u0442\u044C"))))));
}
